module.exports = __webpack_public_path__ + "static/og-2db292d28f567e52b29fe1c9b41941dd.png";